import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Bowser from "bowser";
import {API_TIMEOUTS_MILLISECONDS} from "commonUtils/enumerations";
import {LOGS_ENDPOINT} from "commonUtils/globalAPISettings";
import {isValidObject} from "commonUtils/utils";
import {postRequest, setHeader} from "repository/genericRepository";

interface log {
  datetime?: string;
  level?: string;
  message?: string;
  pagename?: string;
  platform?: string;
  os?: string;
  engine?: string;
  browser?: string;
}

interface loggerProps {
  logger: log[];
}

const initialState: loggerProps = {
  logger: [],
};

const browserInfo = Bowser.parse(window.navigator.userAgent);

export const postLogsToAPI = createAsyncThunk<any, any>(
  "logger/postLogsToAPI",
  async (payload, {rejectWithValue}) => {
    try {
      const {logger} = payload.logs;
      const APIHeaders = {
        Authorization: `Bearer ${payload.token}`,
      };

      const details = await postRequest({
        url: LOGS_ENDPOINT,
        headers: setHeader(APIHeaders),
        params: {logger},
        timeout: API_TIMEOUTS_MILLISECONDS.LOGS_ENDPOINT,
        data: {},
      });
      if (isValidObject(details)) {
        return details;
      }
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

const loggerSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    trackLogs: (state, action) => {
      state.logger.push({
        ...action.payload,
        platform: browserInfo?.platform?.type,
        os: `${browserInfo?.os?.name}-${browserInfo?.os?.version}-${browserInfo?.os?.versionName}`,
        engine: `${browserInfo?.engine?.name}`,
        browser: `${browserInfo?.browser?.name}-${browserInfo?.browser?.version}-${browserInfo?.engine?.name}`,
      });
    },
    clearlogs: state => {
      state.logger = [];
    },
  },
});

export const {clearlogs, trackLogs} = loggerSlice.actions;

export default loggerSlice.reducer;
